<template>
  <form id="edit_device_form">
    <div class="card card-custom gutter-b">
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label" dir="ltr">
            {{ adminDevice.name }}
          </h3>
        </div>
      </div>
      <div class="card-body">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>نام</label>
                <input
                  type="text"
                  name="name"
                  v-model="form.name"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="required">کد</label>
                <input
                  type="text"
                  name="code"
                  v-model="form.code"
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Swal from "sweetalert2";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import {
  DESTROY_ADMIN_DEVICE,
  FETCH_ADMIN_DEVICE,
  UPDATE_ADMIN_DEVICE
} from "@/core/services/store/admin/devices.module";
import { mapGetters } from "vuex";
import _ from "lodash";

export default {
  name: "companyDevicesEdit",
  data() {
    return {
      loaded: false,
      form: {}
    };
  },
  beforeMount() {
    const { id: deviceId } = this.$route.params;
    this.loaded = false;
    this.$store
      .dispatch(FETCH_ADMIN_DEVICE, deviceId)
      .then(() => {
        this.$store.dispatch(SET_BREADCRUMB, [
          {
            title: "مدیریت",
            route: { name: "admin-dashboard" }
          },
          { title: "کاربران", route: { name: "admin-devices-index" } },
          { title: this.gFullName(this.adminDevice) }
        ]);

        this.loaded = true;
      })
      .catch(() => {
        this.loaded = true;
      });
  },
  mounted() {
    this.$store.dispatch(SET_ACTIONS, {
      buttons: [
        {
          name: "ذخیره",
          event: "edit-device-event",
          class: "btn-primary",
          id: "edit-device-btn"
        },
        {
          name: '<i class="flaticon2-trash"></i>حذف',
          event: "delete-device-event",
          class: "btn-danger"
        }
      ],
      links: [
        {
          name: "بازگشت",
          to: { name: "admin-devices-index" }
        }
      ]
    });
    this.eventHub.$on("edit-device-event", this.save);
    this.eventHub.$on("delete-device-event", this.destroy);

    this.fv = formValidation(document.getElementById("edit_device_form"), {
      fields: {
        first_name: {
          validators: {
            notEmpty: {
              message: "نام صحیح نیست."
            }
          }
        },
        last_name: {
          validators: {
            notEmpty: {
              message: "نام صحیح نیست."
            }
          }
        },
        email: {
          validators: {
            emailAddress: {
              message: "ایمیل صحیح نیست."
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },
  beforeDestroy() {
    this.eventHub.$off(["edit-device-event", "delete-device-event"]);
    document.getElementById("edit-device-btn").disabled = false;
  },
  watch: {
    originalForm: {
      handler() {
        this.form = _.cloneDeep(this.originalForm);
      },
      deep: true
    },

    form: {
      handler() {
        document.getElementById("edit-device-btn").disabled = _.isEqual(
          this.form,
          this.originalForm
        );
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["adminDevice"]),
    originalForm() {
      if (!this.loaded) {
        return;
      }
      return {
        id: this.adminDevice.id,
        name: this.adminDevice.name,
        type: this.adminDevice.type,
        code: this.adminDevice.code,
        enabled: true
      };
    }
  },
  methods: {
    save() {
      this.fv.validate().then(status => {
        if (status === "Valid") {
          let submitBtn = document.getElementById("edit-device-btn");
          this.disableBtn(submitBtn);
          this.$store
            .dispatch(UPDATE_ADMIN_DEVICE, this.form)
            .then(device => {
              this.enableBtn(submitBtn);
              this.$router.push({
                name: "admin-devices-show",
                params: { id: device.id }
              });
            })
            .catch(() => {
              this.enableBtn(submitBtn);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا فرم را به شکل صحیح کامل کنید");
        }
      });
    },
    destroy() {
      let id = this.$route.params.id;
      Swal.fire({
        title: "",
        text: "آیا از حذف دستگاه اطمینان دارید؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "بله",
        confirmButtonColor: "#4554a0",
        cancelButtonText: "خیر",
        cancelButtonColor: "#ed1c24",
        heightAuto: false
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch(DESTROY_ADMIN_DEVICE, id).then(() => {
            this.$router.push({
              name: "admin-devices-index"
            });
          });
        }
      });
    }
  }
};
</script>
